import { ObjectValues } from '../common';

export const CONTACT_US_TYPES = {
  PLAN: 'PLAN',
  CONTACT: 'CONTACT',
  SUPPORT: 'SUPPORT',
  OTHER: 'OTHER ',
} as const;

export type ContactUsTypes = ObjectValues<typeof CONTACT_US_TYPES>;
